module.exports = __webpack_public_path__ + "img/HochOben.af524b0f.svg";